import { Message } from 'element-ui';
import { confirmBtnLoading } from './component/utils';
import { formatBatchSignRequestParams } from './util';
import { receiptSign, getAttachmentDetail, uploadReceipt, deletePicture } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { SIGN_STATUS } from './component/utils/constant.js';

// 批量签收
export const batchReceiptEntity = {
    /**
     * @description 校验批量签收是否满足操作条件
     * @param {Array} selected 选中的表格数据
     */
    validateBatchReceipt(selected) {
        const isNotEmpty = selected.length > 0; // 是否选中数据
        const signStatusIsTrue = selected.every(v => v.signStatus === SIGN_STATUS.SIGN_PENDING); // 只能是待签收状态
        const isExpressNoList = selected.filter(item => Boolean(item.expressNo)).length; // 存在快递单号，不允许签收
        if (!isNotEmpty) {
            return Message.warning('请选择运单！');
        }
        if (!signStatusIsTrue) {
            return Message.warning('选中运单只能是待签收状态！');
        }
        if (isExpressNoList) {
            return Message.warning('存在已发快递的单号，不允许签收!');
        }
    },
    /**
     * @description 批量签收接口请求
     * @param {Object} params 接口参数
     * @returns 返回值是一个promise对象
     */
    handleReceiptSign(params) {
        return receiptSign(params).then(res => {
            if (Array.isArray(res.data) && res.data.length > 0) {
                return Promise.reject(res.data[0].message);
            } else {
                return Promise.resolve('批量签收成功');
            }
        });
    },
    // 执行函数
    action(ctx) {
        const isFail = batchReceiptEntity.validateBatchReceipt(ctx.selected);
        if (!isFail) {
            confirmBtnLoading('确定批量签收选中数据?', formatBatchSignRequestParams(ctx.selected), batchReceiptEntity.handleReceiptSign, ctx.getList);
        }
    }
};

// 批量逾期
export const validateBatchOverdueRegister = (selected) => {
    const isNotEmpty = selected.length > 0; // 是否选中数据
    if (!isNotEmpty) {
        Message.warning('请选择运单！');
        return false;
    }
    return true;
};

// 附件
export const attachmentEntity = {
    getAttachmentList(id) {
        const param = {
            objId: id, // objId 当前签收列表数据id
            objType: 'RECEIPT_CONFIRM' // 签收类型 固定传RECEIPT_CONFIRM
        };
        return getAttachmentDetail(param).then(res => {
            if (res && +res.code === 0) {
                return Promise.resolve(res.data || []);
            } else {
                return Promise.reject(new Error('获取附件失败'));
            }
        });
    },
    // 获取上传附件参数
    getUploadParams(ctx, response) {
        return {
            createUserName: ctx.user.userName, // 上传人
            createUserCode: ctx.user.userCode, // 上传人编码
            signFileUpload: 'N', // 是否回传 (Y：已回传 N：未回传)
            receiptSource: '10', // 上传方式 (0：APP端 10：PC端 20：微信)
            taskNoList: [ctx.rowData.taskNo], // 批量上传运输单号集合
            fileUrls: response.map(v => v.fileUrl), // 上传附件的url集合
            fileData: response.map(v =>
                ({
                    fileName: v.fileName,
                    fileUrl: v.fileUrl,
                    picType: ctx.picType || '0' // 普通照片--"0";SN码照片--"1";货物正面照--"2"
                })
            ) // 上传附件的url、name、type集合
        };
    },
    // 上传附件
    upload(ctx, response) {
        const params = attachmentEntity.getUploadParams(ctx, response);
        return uploadReceipt(params).then(res => {
            if (res) {
                if (Array.isArray(res.data) && res.data.length > 0) {
                    return Promise.reject(res.data[0].message || '');
                } else {
                    return Promise.resolve();
                }
            }
        });
    },
    // 删除附件
    delAttachment(taskNo, filePath) {
        return deletePicture({ taskNo, filePath });
    }
};
